import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Software Engineer Intern",
          "Full Stack Developer",
          "React.js Developer",
          "AI/ML Enthusiast",
          "Competitive Programmer",
          "FinTech Developer",
          "Open Source Contributor",
          "IOT Student",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
